import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import TitledSection from '../../../../v2BaseComponents/TitledSection';
import { ContentStack } from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';

const intl = getIntl('profile-add-patient-instructions', {
    header: 'Searching for Your Patient Portal',
    goodPlaceToStartPretext: 'Good Place to Start: ',
    goodPlaceToStart: 'Type in the health system or hospital name you know.',
    broadenYourSearchPretext: 'Broaden Your Search: ',
    broadenYourSearch: 'Unsure of the exact name? Try entering the full name of your state for a comprehensive list.',
    thinkBigPretext: 'Think Big: ',
    thinkBig:
        "Remember, many hospitals and doctor's offices belong to larger health networks. Consider searching for the bigger health system to find the right connection.",
    facilitatedBy1upHealth: 'Connection facilitated by 1upHealth.',
});

export type AddPortalInstructionsOwnProps = {};

export type AddPortalInstructionsProps = AddPortalInstructionsOwnProps;

const AddPortalInstructions: React.FC<AddPortalInstructionsProps> = () => {
    return (
        <TitledSection title={intl('header')}>
            <ContentStack>
                {[
                    { pretext: intl('goodPlaceToStartPretext'), text: intl('goodPlaceToStart') },
                    { pretext: intl('broadenYourSearchPretext'), text: intl('broadenYourSearch') },
                    { pretext: intl('thinkBigPretext'), text: intl('thinkBig') },
                ].map(({ pretext, text }) => (
                    <Text key={text} variant="body-1">
                        <Text variant="bold-body-1">{pretext}</Text>
                        <Text variant="body-1">{text}</Text>
                    </Text>
                ))}
                <Text variant="body-1">{intl('facilitatedBy1upHealth')}</Text>
            </ContentStack>
        </TitledSection>
    );
};

export default React.memo(AddPortalInstructions);
